var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.875C1 1.39175 1.39175 1 1.875 1H14.125C14.6082 1 15 1.39175 15 1.875V6.63889C15 7.12214 14.6082 7.51389 14.125 7.51389H1.875C1.39175 7.51389 1 7.12214 1 6.63889V1.875ZM2.75 2.75V5.76389H13.25V2.75H2.75ZM1 9.36111C1 8.87786 1.39175 8.48611 1.875 8.48611H8C8.48325 8.48611 8.875 8.87786 8.875 9.36111V14.125C8.875 14.6082 8.48325 15 8 15H1.875C1.39175 15 1 14.6082 1 14.125V9.36111ZM2.75 10.2361V13.25H7.125V10.2361H2.75ZM9.84722 9.36111C9.84722 8.87786 10.239 8.48611 10.7222 8.48611H14.125C14.6082 8.48611 15 8.87786 15 9.36111V14.125C15 14.6082 14.6082 15 14.125 15H10.7222C10.239 15 9.84722 14.6082 9.84722 14.125V9.36111ZM11.5972 10.2361V13.25H13.25V10.2361H11.5972Z",
    fill: "#051016"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.76389V2.75H13.25V5.76389H2.75Z",
    fill: "#051016"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.25V10.2361H7.125V13.25H2.75Z",
    fill: "#051016"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5972 13.25V10.2361H13.25V13.25H11.5972Z",
    fill: "#051016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.789d12d778cecd8f87cff5801a45ee3e.svg";
export { ForwardRef as ReactComponent };